import type { ReactNode } from "react";

import { Stack, Text, Title } from "~/ui";

type DocumentSettingsSectionProps = {
  title: string;
  description?: string;
  children: ReactNode;
  /** Inner stack spacing between grouped fields (default lg). */
  spacing?: "lg" | "md" | "xs";
};

/**
 * Top-level PDF-order section for document org settings forms.
 * Use Title order={4} — stronger than per-field headings inside the group.
 * @see docs/OPT_IN_ORDER_DOCUMENTS.md § Document settings UI conventions
 */
export const DocumentSettingsSection = ({ title, description, children, spacing = "lg" }: DocumentSettingsSectionProps) => (
  <section>
    <Title order={4}>{title}</Title>
    {description ? (
      <Text size="sm" color="dimmed" mb="md">
        {description}
      </Text>
    ) : null}
    <Stack spacing={spacing}>{children}</Stack>
  </section>
);
